export default __webpack_public_path__ + "static/media/contacting.72a7c64c.png";